/* istanbul ignore file */
import { FormRow } from 'framework/ui/layout';
import { CurrencyDropdown } from 'domain/shared/core/input';
import { TextInput } from 'framework/form';
import {
  BaseAmountTypeDropdown,
  EmployeeContractTypeDropdown,
  OfficeDropdown,
  OFFICE_NAMES,
} from 'domain/shared/employee';
import { Box } from '@mui/material';
import OfferProbationPeriodReductionInput from '../shared/field/OfferProbationPeriodReductionInput';

interface OfferCompensationDetailsInputProps {
  source: string;
}

const CandidateOfferCompensationDetailsInput = ({ source, ...props }: OfferCompensationDetailsInputProps) => {
  return (
    <Box sx={{ width: { xs: '100%', sm: '100%', md: '100%', xl: '100%' } }}>
      <FormRow colXl={4}>
        <BaseAmountTypeDropdown source={`${source}.baseAmountType`} placeholder=" " label="Base amount type" />
        <CurrencyDropdown source={`${source}.currency`} label="Currency" placeholder=" " />
        <TextInput source={`${source}.finalAmountGross`} label="Final amount gross" />

        <TextInput source={`${source}.probationAmountGross`} label="Probation amount gross" />
        <TextInput
          source={`${source}.calculatedAmountGross`}
          label="Calculated amount gross"
          tooltip="Amount calculated by qualification model"
        />
        <OfferProbationPeriodReductionInput
          saveToContext
          source={`${source}.probationPeriodReduction`}
          probationAmountSource={`${source}.probationAmountGross`}
          baseAmountSource={`${source}.finalAmountGross`}
          label="Probation period reduction, %"
        />

        <OfficeDropdown
          mapResults={(office: any) => ({
            value: OFFICE_NAMES[office.name].toUpperCase(),
            label: OFFICE_NAMES[office.name],
          })}
          source={`${source}.office`}
          label="Office"
          placeholder=" "
        />
        <EmployeeContractTypeDropdown source={`${source}.contractType`} label="Contract Type" placeholder=" " />
      </FormRow>
    </Box>
  );
};

export default CandidateOfferCompensationDetailsInput;
